import { createQuery } from '@datorama/akita';
import store from 'state/Design/store';

export const query = createQuery(store);
export const value$ = query.select();
export const loading$ = query.selectLoading();